import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            path: "/home",
            component: () => import('@/pages/Home'),
            meta: {
                keepAlive: true
            }
        },
        {
            path: "/search",
            component: () => import('@/pages/Search'),
            meta: {
                keepAlive: true // 需要缓存
            }
        },
        {
            path: "/login",
            component: () => import('@/pages/Login'),
        },
        {
            path: "/goods-detail",
            component: () => import('@/pages/GoodsDetail')
        },
        {
            path: "/setting",
            component: () => import('@/pages/Setting'),
            children: [
                {
                    path: "/setting/mine-auth",
                    component: () => import('@/pages/Setting/mine-auth/index.vue')
                },
                {
                    path: "/setting/mine-window",
                    component: () => import('@/pages/Setting/mine-window/index.vue')
                },
                {
                    path: "/setting/mine-collection",
                    component: () => import('@/pages/Setting/mine-collection/index.vue')
                }
            ]
        },
        {
            path: "/business",
            component: () => import('@/pages/Business'),
            children: [
                {
                    path: "/business/goods-manager",
                    component: () => import('@/pages/Business/goods-manager/index.vue')
                },
                {
                    path: "/business/order-list",
                    component: () => import('@/pages/Business/order-list/index.vue')
                },
                {
                    path: "/business/goods-import",
                    component: () => import('@/pages/Business/goods-import/index.vue')
                },
                {
                    component: () => import('@/pages/Business/integral-center/index.vue'),
                    path: '/business/integral-center'
                },
                {
                    component: () => import('@/pages/Business/recharge/index.vue'),
                    path: '/business/recharge'
                },
                {
                    component: () => import('@/pages/Business/arrow-order-rule/index.vue'),
                    path: '/business/arrow-order-rule'
                },
                {
                    component: () => import('@/pages/Business/charging-rule/index.vue'),
                    path: '/business/charging-rule'
                }
            ]
        },
        {
            path: "/",
            redirect: "/home"
        }
    ]
})
